import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/hooks/useRedux';
import { FunnelType } from '@/types/types';
import { resetBookingOriginDestination, resetBookingStates, setFunnelType } from '@/redux/bookingSlice';
import { resetTravellersStates } from '@/redux/travellersSlice';
import GiftIcon from '@/assets/icons/gift.svg?react';
import WorldIcon from '@/assets/icons/world.svg?react';
import NewTagIcon from '@/assets/icons/new-tag.svg?react';
import useRoutes from '@/hooks/useRoutes';
import styles from './FunnelTypeSelector.module.scss';

const FunnelTypeSelector = () => {
    const currentFunnelType = useAppSelector((state) => state.booking.funnelType);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { currentPathname, routes } = useRoutes();
    const isAloyHome = currentPathname === routes.aloyHome;

    const onFunnelTypeSelect = (newFunnelType: FunnelType) => {
        if (newFunnelType === currentFunnelType) return;

        let routeToNavigate = routes.home;

        if (newFunnelType === FunnelType.explore) {
            routeToNavigate = routes.aloyHome;
        }

        dispatch(resetBookingStates());
        dispatch(setFunnelType(newFunnelType));
        dispatch(resetBookingOriginDestination());
        dispatch(resetTravellersStates());
        navigate(routeToNavigate);
    };

    return (
        <div className={styles.funnelTypeContainer}>
            <button
                onClick={() => onFunnelTypeSelect(FunnelType.explore)}
                className={`${styles.funnelTypeOption} ${styles.funnelTypeExplore} ${isAloyHome && styles.selected}`}
            >
                <WorldIcon className={styles.icon} />
                {t('flightsPlusHotel')}
                <NewTagIcon className={styles.tagNew} />
            </button>
            <button
                onClick={() => onFunnelTypeSelect(FunnelType.surprise)}
                className={`${styles.funnelTypeOption} ${styles.funnelTypeSurprise} ${!isAloyHome && styles.selected}`}
            >
                <GiftIcon className={styles.icon} />
                {t('surpriseTrips')}
            </button>
        </div>
    );
};

export default FunnelTypeSelector;
